module.exports = __webpack_public_path__ + "static/media/bg-pic-photos.6975586b.jpg";